<template>
  <v-list flat dense>
    <v-list-item-group v-model="selectedItems" multiple>
      <template v-for="(item, i) in items">
        <template v-if="item.divider">
          <v-divider :key="`item-${i}`" v-show="item.divider ? true : false"></v-divider>
          <v-subheader
            :key="`subheader-${i}`"
            small
            v-show="typeof item.divider === 'string'"
          >{{ item.divider }}</v-subheader>
        </template>
        <v-list-item
          v-else
          :key="`item-${i}`"
          :value="item"
          active-class="text--accent-4"
          :disabled="item.divider ? true : false"
          @click="getLocation(item)"
        >
          <v-list-item-title>{{ item }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

import appConfig from '../config/appConfig';

export default {
  data() {
    return {
      allLocations: ['All Locations'],
      complexSelection: ['United States', 'Canada'],
      canada: [],
      unitedStates: [],
      items: [],
      selectedItems: []
    };
  },
  computed: {
    ...mapGetters({
      locations: 'filterData/locations'
    })
  },
  mounted() {
    this.unitedStates = [
      ...this.locations
        .filter(
          (l) =>
            l.country && l.country !== null && l.country.toLowerCase() ==
            appConfig.locationApiProps.usaCountryValue.toLowerCase()
        )
        .map((s) => s.state)
        .sort()
    ];
    this.canada = [
      ...this.locations
        .filter(
          (l) =>
            l.country && l.country !== null && l.country.toLowerCase() ==
            appConfig.locationApiProps.canadaCountryValue.toLowerCase()
        )
        .map((s) => s.state)
        .sort()
    ];

    this.items = [
      ...this.allLocations,
      // { divider: true },
      //  ...this.complexSelection,
      { divider: 'United States' },
      ...this.unitedStates,
      { divider: 'Canada' },
      ...this.canada
    ];
    this.selectedItems = this.items;
  },
  methods: {
    ...mapActions({
      selectItem: 'mapTemplate/selectItem'
    }),
    ...mapMutations(['setCurrentView']),
    getLocation(item) {
      // TODO - The way we are identifying Global/USA/Canada selections maybe
      // needs to be reworked. This hard-coded approach seems less than ideal.
      if (item === 'All Locations') {
        this.selectItem({
          value: appConfig.countriesApiProps.globalCountryValue,
          type: 'Country'
        });
        // } else if (item === 'United States') {
        //   this.selectItem({
        //     value: appConfig.countriesApiProps.usaCountryValue,
        //     type: 'Country'
        //   });
        // } else if (item === 'Canada') {
        //   this.selectItem({
        //     value: appConfig.countriesApiProps.canadaCountryValue,
        //     type: 'Country'
        //   });
      } else {
        this.selectItem({ value: item, type: 'Geography' });
      }
      //this.setCurrentView('MapView');
    }
  }
};
</script>

<style lang="scss" scoped></style>
